export default __webpack_public_path__ + "b5db5f9634d254bf519027ec5d90427c.svg";